import moment from 'moment';

export const formatDate = date => date && moment(date).format('YYYY-MM-DD');

export const formatIds = idsString => `${idsString}`.replace(/\s/g, '').split(',');
